module.exports = __webpack_public_path__ + "img/12_70.19d2b603.png";